import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const addDomainName = (data) => {
    return apiRequestType(apiTypes.POST, apiConstants.ADMIN.ORGANIZATION_SETTINGS.POST_DOMAIN_NAME, data)
}
export default addDomainName